import React from 'react'
import dynamic from 'next/dynamic'
import LazyLoad from 'react-lazyload'
import PropTypes from 'prop-types'
import OurPrinciplesItem from './OurPrinciplesItem'

const SlickSlider = dynamic(() =>
  import('../../../../shared/BrandPages/SlickSlider')
)

const OurPrinciplesComponent = ({ data }) =>
  data.map((item, index) => <OurPrinciplesItem {...item} key={index} />)

const OurPrinciplesSlider = ({ data }) => {
  const settings = {
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 361,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 380,
        settings: {
          slidesToShow: 1.19,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1.24,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 1.32,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1023,
        settings: {
          speed: 100,
          slidesToShow: 1.2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          speed: 100,
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },

      {
        breakpoint: 1600,
        settings: {
          speed: 100,
          slidesToShow: 4,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 3000,
        settings: {
          speed: 100,
          slidesToShow: 4,
          slidesToScroll: 3,
        },
      },
    ],
  }

  return (
    <LazyLoad placeholder={<OurPrinciplesComponent data={data} />}>
      <SlickSlider sliderSettings={settings}>
        {data.map((item, index) => (
          <OurPrinciplesItem {...item} key={index} />
        ))}
      </SlickSlider>
    </LazyLoad>
  )
}

OurPrinciplesSlider.propTypes = {
  data: PropTypes.array.isRequired,
}

export default OurPrinciplesSlider
